/* Match the desktop shell: the matrix uses the space left below its controls. */
.admin-page .access-tab-content {
  display: grid;
  gap: 0.5rem;
}

.admin-page .access-role-editor > nav {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}

@media (min-width: 1281px) {
  .admin-page,
  .admin-page .access-section,
  .admin-page .access-roles-panel {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  .admin-page > *,
  .admin-page .access-section > *,
  .admin-page .access-roles-panel > *,
  .admin-page .access-role-editor > * {
    flex-shrink: 0;
  }

  .admin-page .access-section {
    overflow-y: auto;
  }

  .admin-page .access-tab-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .admin-page .access-tab-content > :not(.access-roles-panel) {
    flex-shrink: 0;
  }

  .admin-page .access-role-editor {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .admin-page .access-role-permissions {
    flex: 1;
    min-height: 12rem;
    max-height: none;
    overflow-y: auto;
    align-content: start;
  }
}
